import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState } from 'react';

import { WsButton } from '../WsButton';
interface IPersonalEmailWarning {
  closePopup(): void;
  saveAccount(): void;
  open: boolean;
}

const PersonalEmailWarning: React.FC<IPersonalEmailWarning> = ({
  closePopup,
  saveAccount,
  open,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const closeDialog = () => {
    setOpenDialog(false);
    closePopup();
  };

  const continueWithMail = () => {
    closeDialog();
    saveAccount();
  };

  return (
    <Dialog fullScreen={fullScreen} open={openDialog} aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">{'Change Email'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          It seems that you are creating an account with your personal or temporary email. We
          recommend you to use work email to get complete access to the standard plan.
        </DialogContentText>
        <DialogContentText>
          With the standard plan, you can invite colleagues to join your workspace, create teams and
          collaborate.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <WsButton onClick={closeDialog}>Change Email</WsButton>
        <WsButton onClick={continueWithMail}>Continue</WsButton>
      </DialogActions>
    </Dialog>
  );
};

export default PersonalEmailWarning;
